import * as React from "react";
import Drawer from "@mui/material/Drawer";
import { Box, styled, useTheme } from "@mui/material";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { IconButton } from "@mui/material";
import TransLang from "./TransLang"
import { Pages } from "../../constants";
import i18next from "i18next";
import logo from './../../assets/Logo/logo.png'
import CloseIcon from '@mui/icons-material/Close';

export default function NavDrawer({ setDrawer, drawer, data }) {
    let lng = i18next.language
    const theme = useTheme()
    const location = useLocation();
    
    const StyledLink = styled(RouterLink)(({ theme, active }) => ({
        textDecoration: "none",
        fontSize: 14,
        textTransform: 'uppercase',
        fontWeight: 500,
        color: active ? theme.palette.nav.hover : theme.palette.nav.link, // 🔹 تغيير اللون
        transition: '0.5s',
        '&:hover': {
            color: theme.palette.nav.hover,
        },
    }));
    return (
        <div>
            <React.Fragment>
                <Drawer
                    anchor={lng === 'en' ? 'left' : 'right'}
                    open={drawer}
                    onClose={() => setDrawer(false)}
                    sx={{
                        '.MuiDrawer-paper': {
                            height: '80% !important ',
                            borderBottomRightRadius: lng === 'en' && '16px',
                            borderBottomLeftRadius: lng === 'ar' && '16px',
                            backgroundColor: theme.palette.nav.main,
                            overflowY: 'auto'
                        }
                    }}
                >
                    <Box
                        sx={{
                            width: 300,
                            gap: 3,
                            display: "flex",
                            flexDirection: "column",
                            textAlign: lng === 'en' ? 'left' : 'right',
                            padding: "40px 20px",
                        }}>
                        <Box
                            sx={{
                                flexGrow: 0,
                                display: { md: "none", xs: "flex" },
                                justifyContent: "space-between",
                                width: "100%",
                                alignItems: "center",
                            }}>
                            <RouterLink to="/">
                                <img src={logo||data?.headerLogo} style={{ height: 'fit-contain' }} alt="logo" className="nav-logo" ></img>
                            </RouterLink>
                            <IconButton 
                                sx={{backgroundColor:'#fff', borderRadius: '6px', p:0.5}}
                            onClick={() => setDrawer(false)}>
                                <CloseIcon sx={{ backgroundColor: '#fff', borderRadius: '6px' }} />
                            </IconButton>
                        </Box>
                        {Pages?.map((page, i) => {
                            const isActive = location.pathname.split('/')[1] === page.path; 
                            return (
                                <StyledLink
                                    key={i}
                                    to={page.path}
                                    className={'text_bold'}
                                    active={isActive ? 1 : 0}
                                    onClick={() => setDrawer(false)}
                                >
                                    {lng === 'ar' ? page.name : page.name_en}
                                </StyledLink>
                            );
                        })}
                        <TransLang />
                    </Box>
                </Drawer>
            </React.Fragment>
        </div>
    );
}
